<template>
  <Transition name="toast">
    <div v-if="visible" class="Toast" role="status" aria-live="polite">
      {{ message }}
    </div>
  </Transition>
</template>

<script>
import { eventBus } from '../../models/events';

export default {
  name: 'Toast',
  data() {
    return {
      message: '',
      visible: false,
      hideTimeout: null,
    };
  },
  mounted() {
    eventBus.$on('toast', this.handleToast);
  },
  beforeDestroy() {
    eventBus.$off('toast', this.handleToast);
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  },
  methods: {
    handleToast({ message, duration = 4000 }) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
      }
      this.message = message;
      this.visible = true;
      this.hideTimeout = setTimeout(() => {
        this.visible = false;
        this.hideTimeout = null;
      }, duration);
    },
  },
};
</script>
